import { useCallback, useEffect, useState } from 'react';

import { SurfaceSchema } from '@plangrid/scribble-client';

import { getSurface } from '../helpers/scribbleApiClient';

const useFetchSurface = (projectId?: string, surfaceUid?: string) => {
  const [surface, setSurface] = useState<SurfaceSchema>();

  const fetchSurface = useCallback(async () => {
    if (!projectId || !surfaceUid) return;
    const surface = await getSurface(projectId, surfaceUid);
    setSurface(surface);
  }, [projectId, surfaceUid]);

  useEffect(() => {
    fetchSurface();
  }, [fetchSurface]);
  return surface;
};

export default useFetchSurface;
